import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [checked, setChecked] = useState(!!location.state?.user);

  useEffect(() => {
    if (location.state?.user) {
      setChecked(true);
      return;
    }
    if (!loading) {
      if (!user) navigate("/login");
      setChecked(true);
    }
  }, [loading, user, location.state, navigate]);

  if (!checked || loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400 font-mono text-sm uppercase tracking-[0.2em]" data-testid="protected-route-loader">
        Chargement...
      </div>
    );
  }
  if (!user && !location.state?.user) return null;
  return children;
};
